import { render, staticRenderFns } from "./StepTwoIcon.vue?vue&type=template&id=4cd6d01a"
import script from "./StepTwoIcon.vue?vue&type=script&lang=js"
export * from "./StepTwoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports